import * as React from 'react';
import styled from 'styled-components';

import { getSemanticAttributes } from '../../internals/semanticProps';
import { rem } from '../../tokens/spacing';
export interface SearchProps extends React.HTMLAttributes<HTMLDivElement> {
  placeholder?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  onClear?: () => void;
  semanticId?: string;
  inputId?: string;
}

const SearchContainer = styled.div`
  position: relative;

  input {
    border: ${rem(1)} solid var(--ui-border-muted);
    border-radius: var(--ui-radius-md, ${rem(6)});
    padding: ${rem(11)} ${rem(40)} ${rem(11)} ${rem(13)};
    width: 100%;
    font-weight: 400;
    font-size: ${rem(15)};
    line-height: ${rem(16)};
    color: var(--ui-text);
    box-sizing: border-box;
    font-family: var(--ui-font-sans);

    box-shadow: ${rem(0)} ${rem(2)} ${rem(4)} var(--ui-shadow-default);
    transition: all 0.2s linear;

    &:hover,
    &:focus {
      border-color: var(--ui-interactive);
      outline: none;
      filter: drop-shadow(${rem(0)} ${rem(2)} ${rem(3)} var(--ui-shadow-default));
    }

    &::placeholder {
      font-weight: 400;
      font-size: 15px;
      line-height: 16px;
      color: var(--ui-border);
    }
  }

  .search-icon {
    font-weight: 400;
    font-size: ${rem(20)};
    transition: all 300ms ease-in;
    position: absolute;
    right: ${rem(14)};
    top: ${rem(10)};
    cursor: pointer;

    &.close {
      color: var(--ui-border-strong);
    }

    &.search {
      color: var(--ui-text-muted);
    }
  }
`;

export const Search = React.forwardRef<HTMLDivElement, SearchProps>(function Search(
  { placeholder = 'Search', value = '', onValueChange, onSearch, onClear, semanticId, inputId, className, ...rest },
  ref,
) {
  const semanticProps = getSemanticAttributes(semanticId);

  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onSearch) {
      onSearch(value);
    }
  };

  return (
    <SearchContainer ref={ref} className={className} {...semanticProps} {...rest}>
      <input
        id={inputId}
        autoComplete="off"
        name="search"
        placeholder={placeholder}
        type="text"
        value={value}
        onKeyUp={handleKeyUp}
        onChange={(e) => onValueChange?.(e.target.value)}
      />
      {value.length > 0 ? (
        <span
          className="material-symbols-outlined search-icon close"
          onClick={() => onClear?.()}
        >
          close
        </span>
      ) : (
        <span
          className="material-symbols-outlined search-icon search"
          onClick={() => onSearch?.(value)}
        >
          search
        </span>
      )}
    </SearchContainer>
  );
});

Search.displayName = 'Search';
